require('./brokerConsensusView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const BrokerSearchAction = require('actions/brokerSearch');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const IFRAME_URL = `https://openbank-analisis.webfg.com/buscadorConsensoMercado/${getLanguage()}`;

class BrokerConsensusView extends React.Component {

    getBreadcrumbData() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerConsensus'),
                url: ''
            }
        ];
    }

    render() {
        const mappingBreadcrumb = this.getBreadcrumbData();

        return (
            <div className="broker-consensus-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerConsensus')}
                    />
                </OKCover>
                <section className="broker-consensus-view__body">
                    <div className="row no-outside-gutter">
                        <ContentBox customClassName="broker-consensus-view__content-box">
                            <iframe
                                className="broker-consensus-view__iframe"
                                src={IFRAME_URL}
                            />
                        </ContentBox>
                    </div>
                </section>
            </div>
        );
    }
}


BrokerConsensusView.propTypes = {
    searchProducts: PropTypes.object,
    handleSearchProduct: PropTypes.func,
    handleSearchReset: PropTypes.func,
};

module.exports.constructor = BrokerConsensusView;
module.exports.BrokerConsensusView = connect(
    state => ({
        brokerState: state.brokerState,
        searchProducts: state.brokerSearch,
    }), {
        handleSearchProduct: BrokerSearchAction.searchProduct,
        handleSearchReset: BrokerSearchAction.clearResults
    })(BrokerConsensusView);
